import { render, staticRenderFns } from "./MusicVideos.vue?vue&type=template&id=4f1f83f0&"
import script from "./MusicVideos.vue?vue&type=script&lang=js&"
export * from "./MusicVideos.vue?vue&type=script&lang=js&"
import style0 from "./MusicVideos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports